import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { StatIcon } from '@/components/atoms/StatIcon';
import type { Ileader } from '../../types/ILeader';
type LeaderItemData = Ileader & {
  currentUser?: boolean;
};
interface TProps {
  data: LeaderItemData;
}
export const LeaderItem = t0 => {
  const $ = _c(31);
  const {
    data
  } = t0;
  const t = useTranslations("LeaderBoard.LeaderItem");
  const t1 = data.currentUser && "bg-[linear-gradient(84.44deg,#D93C14_2.52%,#FF7A00_93.65%)]";
  let t2;
  if ($[0] !== t1) {
    t2 = clsx("flex w-full items-center justify-between gap-2 rounded-[10px] bg-[#31324B99] p-1 align-baseline sm-tablet:gap-3 sm-tablet:p-2", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = data.currentUser ? "text-white" : "text-[#B2B4CF]";
  let t4;
  if ($[2] !== t3) {
    t4 = clsx("min-w-[28px] rounded-[6px] bg-[#00000040] px-2 py-0.5 text-center text-[12px] font-semibold  sm-tablet:min-w-[38px] sm-tablet:rounded-[8px]  sm-tablet:px-[15px] sm-tablet:py-[2.5px] sm-tablet:text-[15px]", t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== data.rank || $[5] !== t4) {
    t5 = <span className={t4}>{data.rank}</span>;
    $[4] = data.rank;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = data.currentUser && "font-semibold";
  let t7;
  if ($[7] !== t6) {
    t7 = clsx("inline-flex w-full flex-grow items-start justify-start whitespace-nowrap text-xs text-[#E9ECF0] sm-tablet:text-[16px]", t6);
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== data.currentUser || $[10] !== data.username || $[11] !== t) {
    t8 = data.currentUser ? t("You") : data.username;
    $[9] = data.currentUser;
    $[10] = data.username;
    $[11] = t;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t7 || $[14] !== t8) {
    t9 = <div className="flex w-full flex-grow items-center gap-2"><span className={t7}>{t8}</span></div>;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = data.currentUser && "bg-[#1A1A1A]";
  let t11;
  if ($[16] !== t10) {
    t11 = clsx("flex items-center gap-1 rounded-full bg-[#00000040] px-2 py-1 sm-tablet:px-2.5", t10);
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <StatIcon type="fanTokens_new" className="h-[18px] w-[18px] sm-tablet:h-[20px] sm-tablet:w-[20px]" />;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== data.poeEarned) {
    t13 = data.poeEarned.toLocaleString("en-US");
    $[19] = data.poeEarned;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t13) {
    t14 = <span className="text-[18px] font-semibold text-[#E9ECF0]  sm-tablet:text-[20px]">{t13}</span>;
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t11 || $[24] !== t14) {
    t15 = <div className={t11}>{t12}{t14}</div>;
    $[23] = t11;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t15 || $[27] !== t2 || $[28] !== t5 || $[29] !== t9) {
    t16 = <div className={t2}>{t5}{t9}{t15}</div>;
    $[26] = t15;
    $[27] = t2;
    $[28] = t5;
    $[29] = t9;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  return t16;
};